import { TextField } from "@material-ui/core";
import React from "react";
import { useState } from "react";
import PropTypes from "prop-types";

/**
 * Controls the feed text edit
 * @param boolean editField
 * @param string message
 * @returns React Component
 */
const EditableFeedMessage = ({ editFeed = false, getFieldProps, message }) => {
  const [commentText, setCommentText] = useState(null);
  // console.log({ fieldProps: getFieldProps("message") });
  return (
    <>
      {!editFeed ? (
        <span className="text-dark-75 font-size-sm font-weight-normal pt-1">
          {message}
        </span>
      ) : (
        <TextField
          multiline
          name="message"
          {...getFieldProps("message")}
          // onChange={(e) => setCommentText(e.target.value)}
        />
      )}
    </>
  );
};

EditableFeedMessage.propTypes = {
  editFeed: PropTypes.bool,
  message: PropTypes.string.isRequired,
};
export default EditableFeedMessage;
